<template>
    <div>
        <div>
            <div class="w-full flex-col shadow-md pb-2 mb-4 bg-white rounded mr-8">
                <div class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                    <span class="pl-2">Contact Analytics</span>
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "contact-analytics",
    props: ['company','contact'],
    data() {
        return {
            projectFilter: '',
            loadingProjects: true,
            projects: null,
            currentProjectOrder: {
                property: '',
                direction: ''
            },
            projectPagination: {
                data: [],
                meta: {},
                links: {},
            },
        }
    },
    mounted() {
    },
    watch: {
        selectedType(val) {
            this.form.company_types_id = val ? val.id : null;
        }
    },
    created() {
      //  this.fetchData();
    },
    methods: {
        fetchData() {
            this.fetchProjects();
            this.getCompanyTypes();
        },
        goToPage(page) {
            this.projectPagination.meta.current_page = page;
            this.fetchProjects();
        },

        fetchProjects() {
            this.loadingProjects = true;
            axios.get(route('api.company.projects', {
                contactId:this.contact.id,
                company: this.company.id,
                filter: this.projectFilter,
                page: this.projectPagination.meta.current_page
            })).then(({data}) => {
                this.projects = data.data;
                this.projectPagination = data;
                this.loadingProjects = false;
            });
        },

        debounceFilterProjects: _.debounce(function (e) {
            this.currentProjectOrder = {property: '', direction: ''}
            this.projectFilter = e.target.value;
            this.fetchProjects()
        }, 500),

        addProject() {
            window.location = route('project.create', {company_id: this.company.id});
        },
        editProject(project) {
            window.location = route('project.edit', {project: project.id, company_id: this.company.id});
        },

        orderProjects(selectedProperty) {
            let newDirection = null;

            if (selectedProperty === this.currentProjectOrder.property) {
                newDirection = this.currentProjectOrder.direction === 'desc' ? 'asc' : 'desc';
            } else {
                newDirection = 'asc';
            }

            this.currentProjectOrder = {property: selectedProperty, direction: newDirection};

            this.projects = _.orderBy(this.projects, p => {
                switch (selectedProperty) {
                    case 'sequential_team_id':
                        return Number(p[selectedProperty]);
                    case 'bid_date':
                        return new Date(p[selectedProperty]);
                    case 'base_bid':
                        return Number(p[selectedProperty].toString().replace(',', ''));
                    case 'contract_date':
                        return new Date(p[selectedProperty]);
                    case 'contract_amount':
                        return Number(p[selectedProperty].toString().replace(',', ''));
                    default:
                        return p[selectedProperty];
                }
            }, newDirection);
        },

        getCompanyTypes() {
            let self = this;
            axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                self.companyTypes = data;
                self.companyTypes.push({id: null, code: ""})
            }).finally(() => {
                if (self.company.company_types_id)
                    self.selectedType = self.companyTypes.find((company) => {
                        return self.company.company_types_id === company.id
                    });
                else
                    self.selectedType = null;
            });
        }
    }
}
</script>

<style scoped>
.recent-files {
    max-height: 35vh;
    min-height: 100px;
    overflow: scroll;
    overflow-y: auto;
}
</style>
